import { useParams as RRuseParams } from 'react-router'

export function useParams<T extends Record<string, string | undefined>>() {
  return RRuseParams<T>() as T
}
